<template>
	<el-table
		:data="orderItems"
		height="250"
		border
		show-summary
		size="mini"
		style="width: 100%"
		v-if="hasGetTableDataModel"
	>
		<el-table-column type="selection" v-if="checkable"></el-table-column>
		<el-table-column type="index" :index="1"></el-table-column>
		<el-table-column
			:prop="key.name"
			:label="dataModels.Order_item[key.name].show_name"
			:sortable="key.sortable"
			:key="index"
			:width="key.width"
			v-for="(key,index) in itemFields"
		>
			<div slot-scope="scope">
				<span v-if="key.isOnlyShow && key.render" v-html="key.render(scope.row)"></span>
				<field-show
					:field-info="dataModels.Order_item[key.name]"
					:value="scope.row[key.name]"
					:field-key="key"
					v-else-if="key.isOnlyShow"
				></field-show>
				<field-editor
					:width="key.width"
					:tips="key.tips"
					v-model="scope.row[key.name]"
					:field-info="dataModels.Order_item[key.name]"
					:record-id="recordId"
					record-model="Order_item"
					@change="onChange(scope.$index)"
					:params="key.params"
					v-else
				></field-editor>
			</div>
		</el-table-column>
		<el-table-column fixed="right" label="操作">
			<template slot-scope="scope">
				<el-button @click="handleRemove(scope.$index)" type="text" size="small">
					<i class="el-icon-delete"></i>
				</el-button>
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	data() {
		return {
			loadings: {
				main: false,
				create: false,
				insert: false,
			},
			recordId: "",
			itemFields: [
				{
					name: "brand_show_id",
					isOnlyShow: true,
				},
        {
          name: "color_code",
          isOnlyShow: true,
        },
        {
          name: "color",
          isOnlyShow: true,
        },
				{
					name: "brand",
					isOnlyShow: true,
				},
				{
					name: "product_color",
					isOnlyShow: true,
					width: "200px",
				},
				{
					name: "model",
					isOnlyShow: true,
				},
				{
					name: "price_per",
				},
				{
					name: "order_amount",
				},
				{
					name: "total_price",
					isOnlyShow: true,
				},
			],
			orderItems:[]
		};
	},
	computed: {
		...mapState(["dataModels", "loadingDM"]),
		// items: {
		// 	get: function() {
		// 		return this.value;
		// 	},
		// 	set: function(newValue) {
		// 		this.$emit("input", newValue);
		// 		this.$emit("change", newValue);
		// 	},
		// },
		hasGetTableDataModel() {
			if (this.dataModels["Order_item"] && this.dataModels["Order_item"]._id) {
				return true;
			} else {
				return false;
			}
		},
	},
	props: {
		value: {
			type: Array,
			default: function() {
				return [];
			},
		},
		checkable: {
			type: Boolean,
			default: false,
		},
		itemData:{
			type:Array,
			default: function() {
				return [];
			},
		}
	},
	methods: {
		doResetAll() {
			this.orderItems = [];
		},
		handleRemove(index) {
			this.orderItems.splice(index, 1);
		},
		onChange(index) {
			this.orderItems[index].total_price = (
				this.orderItems[index].price_per * this.orderItems[index].order_amount
			).toFixed(2);
		},
		// handleSelectionChange(val) {
		// 	let idMapping = {};
		// 	val.forEach(item => {
		// 		idMapping[item._id] = 1;
		// 	});
		// 	this.items.forEach(item => {
		// 		if (idMapping[item._id]) {
		// 			item.checked = true;
		// 		} else {
		// 			item.checked = false;
		// 		}
		// 	});
		// 	this.$emit("select", this.items);
		// },
	},
	watch:{
		itemData(val){
			this.orderItems = val
			for(let k in this.orderItems){

				console.log("OrderItems.order_amount",this.orderItems[k]['order_amount'])
			}
			// console.log('items:', this.orderItems)
			// this.$emit("select", this.orderItems);
		}
	}
};
</script>
<style lang="scss" scoped>
</style>
